import { useEventBus, usePagination } from '@byted/hooks';
import { Pagination } from '@douyinfe/semi-ui';
import {
  PaginationData,
  PaginationRequestFnType,
} from '@byted/hooks/lib/useSemiPagination';
import { useEffect } from 'react';
import { ReplyList } from './ReplyList';
import { CommentItem } from './Post/CommentItem';
import { forumPostService } from '@/api/forumPost';
import { Comment } from '@/typings/open.platform.forum_bff/namespaces/forum';
import useBiz from '@/context/useBiz';
import useComment from '@/context/useComment';

type Props = {
  postId: string;
  isAdmin?: boolean;
};

export const CommentList: React.FC<Props> = ({ postId }: Props) => {
  const biz = useBiz(state => state.biz);
  const fetcher: PaginationRequestFnType<PaginationData<Comment>> = async ({
    current,
    pageSize,
  }) => {
    const res = await forumPostService.getCommentList({
      PageNo: current,
      PageSize: pageSize,
      PostId: postId,
      Uid: '',
      Biz: biz,
    });
    if (res.error) {
      return {
        total: 0,
        list: [],
      };
    } else {
      return {
        total: Number(res.data.Total),
        list: res.data.Comments || [],
      };
    }
  };
  const {
    data: commentList,
    pagination,
    reset: reFetchComment,
  } = usePagination(fetcher, {
    auto: true,
    refreshDeps: [postId],
    pageSize: 10,
    defaultPageSize: 10,
  });

  useEffect(() => {
    useComment.setState({ reFetchComment });
  }, [reFetchComment]);
  useEventBus('RELOAD_COMMENT', () => {
    reFetchComment();
  });

  if (!postId) {
    return null;
  }

  return (
    <div className="mt-2">
      {commentList?.list.map(comment => (
        <div key={comment.Id} className={'mb-8'}>
          <div>
            <CommentItem content={comment} />
            <div className="ml-8 mt-2">
              <ReplyList commentId={comment.Id} />
            </div>
          </div>
        </div>
      ))}
      <div className="flex  justify-end ">
        {<Pagination {...pagination} showTotal={true} />}
      </div>
    </div>
  );
};
